import { AppContext } from "@/services/AppContext/appContext";
import { BasicTask, EditedTask, SearchTask } from "@/types";
import { convertOldBasicTask } from "@/utils/utils";
import { Dispatch, RefObject, SetStateAction, useContext } from "react";
import { useParams } from "react-router";

const useSingleClick = (
  task: BasicTask | SearchTask,
  isEditing: boolean,
  selectedEditableTask: EditedTask | null,
  editedTask: EditedTask | null,
  setIsEditing: Dispatch<SetStateAction<boolean>>,
  setSelectedEditableTask: Dispatch<SetStateAction<EditedTask | null>>,
  setEditedTask: Dispatch<SetStateAction<EditedTask | null>>,
  rowRef: RefObject<HTMLDivElement>,
  clickTimeout: NodeJS.Timeout | null,
  setClickTimeout: Dispatch<SetStateAction<NodeJS.Timeout | null>>
) => {
  const { taskID } = useParams();
  const { userTags } = useContext(AppContext);

  const handleSingleClick = () => {
    if (task.id.toString() === taskID) {
      return;
    }

    if (clickTimeout) {
      clearTimeout(clickTimeout);
    }
    if (isEditing) {
      return;
    }

    setClickTimeout(
      setTimeout(() => {
        if (rowRef.current) {
          rowRef.current.style.outline = "1px solid #cccccc50";
          setIsEditing(true);
          const convertedTask = convertOldBasicTask(task, userTags);
          if (!selectedEditableTask) {
            setSelectedEditableTask(convertedTask);
          }
          if (!editedTask) {
            setEditedTask(convertedTask);
          }
        }
      }, 250)
    );
  };

  return { handleSingleClick };
};

export default useSingleClick;
